/**
 * Created by slava on 20/3/20
 */

const UndoBlock = cc.Node.extend({
    ctor: function (movesLog) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.log = movesLog;
        this.booster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_UNDO);

        this.createContent();
        this.onChangeAmount();
        this.setCascadeOpacityEnabledRecursively(true);

        this.state = UndoBlock.NONE;
        this.updateState(true);

        this.booster.on("changeAmount", this.createListener(this.onChangeAmount.bind(this)), this);
        cleverapps.adsLimits.on("update", this.onChangeAmount.bind(this), this);
        cleverapps.user.on("changeHard", this.onChangeAmount.bind(this), this);

        this.log.on("change", this.updateState.bind(this));
        this.log.on("showAlert", this.undoButton.showAlert.bind(this.undoButton));
    },

    createContent: function () {
        this.createPrice();
        this.undoButton = new UndoButton({
            onPressed: this.onClicked.bind(this)
        });

        const content = new cleverapps.Layout([this.undoButton, this.priceBlock].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL
        });
        content.setAnchorPoint(0.5, 0);
        this.setContentSize2(content.getContentSize());
        content.setAlignment(content.width / 2, content.height / 2);
        this.addChild(content);

        this.onResize();
    },

    onResize: function () {
        if (this.priceBlock && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.priceBlock.setScale(cleverapps.styles.UndoBlock.priceBlock.mobileScale);
        } else {
            this.priceBlock.setScale(1);
        }
    },

    createPrice: function () {
        const styles = cleverapps.styles.UndoBlock;

        const price = this.price = new TextWithIcon(`$$${this.booster.getPrice().amount}`, { font: cleverapps.styles.FONTS.TEXT });

        const amount = this.amount = cleverapps.UI.generateImageText(`x${this.booster.getAmount()}`, cleverapps.styles.FONTS.AMOUNT_BOOSTER);

        const ads = this.ads = new TextWithIcon("## x1", {
            font: cleverapps.styles.FONTS.BUTTON_BOOSTER
        });

        this.priceBlock = new cc.Scale9Sprite(bundles.small_timer.frames.small_timer_bg_png);
        this.priceBlock.setContentSize2(price.width + 2 * styles.priceBlock.bg.padding.x, price.height + 2 * styles.priceBlock.bg.padding.y);
        this.priceBlock.addChild(price);
        this.priceBlock.addChild(amount);
        this.priceBlock.addChild(ads);

        amount.setAlignment(this.priceBlock.width / 2, this.priceBlock.height / 2);
        price.setAlignment(this.priceBlock.width / 2, this.priceBlock.height / 2);
        ads.setAlignment(this.priceBlock.width / 2, this.priceBlock.height / 2);
    },

    onClicked: function () {
        cleverapps.focusManager.display({
            focus: "ExecuteUndoBooster",
            stack: true,
            action: function (f) {
                this.booster.onPressed(f);
            }.bind(this)
        });
    },

    updateState: function (silent) {
        if (this.log.isEmpty()) {
            if (this.state !== UndoBlock.UNAVAILABLE) {
                this.state = UndoBlock.UNAVAILABLE;
                this.fadeOut(silent);
            }
        } else if (this.state !== UndoBlock.AVAILABLE) {
            this.state = UndoBlock.AVAILABLE;
            this.fadeIn(silent);
        }
    },

    fadeIn: function (silent) {
        if (silent) {
            this.undoButton.enable();
            this.priceBlock.setOpacity(255);
            return;
        }

        this.undoButton.enable();
        this.undoButton.setVisible(true);
        this.undoButton.background.setAnimation(0, "fadein", false);
        this.priceBlock.stopAllActions();
        this.priceBlock.runAction(new cc.Sequence(
            new cc.Show(),
            new cc.FadeIn(0.5)
        ));
    },

    fadeOut: function (silent) {
        if (silent) {
            this.priceBlock.setOpacity(0);
            this.undoButton.setVisible(false);
            return;
        }
        this.undoButton.disable();
        this.undoButton.background.setAnimation(0, "fadeout", false);
        this.priceBlock.stopAllActions();
        this.priceBlock.runAction(new cc.Sequence(
            new cc.FadeOut(0.6),
            new cc.Hide(),
            new cc.CallFunc(() => {
                this.undoButton.setVisible(false);
            })
        ));
    },

    onChangeAmount: function () {
        const boosterState = this.booster.getState();
        this.setAmount(this.booster.getAmount());
        this.amount.setVisible(boosterState === BaseBooster.AMOUNT_STATE);
        this.price.setVisible(boosterState === BaseBooster.PRICE_STATE);
        this.ads.setVisible(boosterState === BaseBooster.ADS_STATE);
    },

    setAmount: function (amount) {
        this.amount.setString(`x${amount}`);
    }
});

UndoBlock.NONE = 0;
UndoBlock.AVAILABLE = 1;
UndoBlock.UNAVAILABLE = 2;

cleverapps.styles.UndoBlock = {
    priceBlock: {
        mobileScale: 0.7,

        bg: {
            padding: {
                x: 5,
                y: 1
            }
        }
    }
};